import { Route } from '@angular/router';

export const referralRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/referral-list.component').then(
        (m) => m.ReferralListComponent
      ),
  },
  {
    path: 'create',
    loadComponent: () =>
      import('./detail/referral-detail.component').then(
        (m) => m.ReferralDetailComponent
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detail/referral-detail.component').then(
        (m) => m.ReferralDetailComponent
      ),
  },
];
